import './preflight.css'
import './index.css'
import 'dayjs/locale/zh-cn'

import { ThemeProvider } from '@emotion/react'
import dayjs from 'dayjs'
import eruda from 'eruda'
import { Provider, useAtomValue } from 'jotai'
import { useEffect } from 'react'

import { myStore } from '@/store/global'

import { AnimatedRoutes } from './router'
import { isDarkState } from './store/theme'
import { darkTheme, lightTheme } from './theme'

dayjs.locale('zh-cn')

export default function Index() {
  const isDark = useAtomValue(isDarkState)

  useEffect(() => {
    console.info(`%c Version %c ${import.meta.env.VITE_APP_TIME} `, 'color: #fff; background: #5f5f5f', 'color: #fff; background: #4bc729')
    if (import.meta.env.VITE_APP_ENV !== 'live') {
      eruda.init()
    }
  }, [])

  return (
    <Provider store={myStore}>
      <ThemeProvider theme={isDark ? darkTheme : lightTheme}>
        <AnimatedRoutes />
      </ThemeProvider>
      {import.meta.env.VITE_APP_ENV !== 'live' ? (
        <div
          onClick={() => {
            if (window.basicW === 75) window.changeScreenMode('horizontal')
            else window.changeScreenMode()
          }}
          className="fixed z-[9999] bottom-0 left-0 w-full flex_center"
        >
          <div className="bottom-0 left-0 px-[4px] text-[#ddd] text-[16px]">{import.meta.env.VITE_APP_TIME}</div>
        </div>
      ) : null}
    </Provider>
  )
}
